/* js/components/HyperButtonVignette.svelte generated by Svelte v3.46.4 */
import {
	SvelteComponent,
	append,
	attr,
	bubble,
	detach,
	element,
	init,
	insert,
	listen,
	noop,
	run_all,
	safe_not_equal,
	set_data,
	space,
	src_url_equal,
	text
} from "svelte/internal";

import { Ripple } from 'svelte-mui';

function create_fragment(ctx) {
	let button;
	let img;
	let img_src_value;
	let t0;
	let p;
	let t1;
	let mounted;
	let dispose;

	return {
		c() {
			button = element("button");
			img = element("img");
			t0 = space();
			p = element("p");
			t1 = text(/*title*/ ctx[1]);
			if (!src_url_equal(img.src, img_src_value = /*imgSrc*/ ctx[0])) attr(img, "src", img_src_value);
			attr(img, "alt", "");
			attr(button, "class", className);
		},
		m(target, anchor) {
			insert(target, button, anchor);
			append(button, img);
			append(button, t0);
			append(button, p);
			append(p, t1);

			if (!mounted) {
				dispose = [
					listen(img, "click", /*click_handler_1*/ ctx[3]),
					listen(button, "click", /*click_handler*/ ctx[2])
				];

				mounted = true;
			}
		},
		p(ctx, [dirty]) {
			if (dirty & /*imgSrc*/ 1 && !src_url_equal(img.src, img_src_value = /*imgSrc*/ ctx[0])) {
				attr(img, "src", img_src_value);
			}

			if (dirty & /*title*/ 2) set_data(t1, /*title*/ ctx[1]);
		},
		i: noop,
		o: noop,
		d(detaching) {
			if (detaching) detach(button);
			mounted = false;
			run_all(dispose);
		}
	};
}

let className = '';

function instance($$self, $$props, $$invalidate) {
	let { imgSrc = null } = $$props;
	let { title = null } = $$props;

	function click_handler(event) {
		bubble.call(this, $$self, event);
	}

	function click_handler_1(event) {
		bubble.call(this, $$self, event);
	}

	$$self.$$set = $$props => {
		if ('imgSrc' in $$props) $$invalidate(0, imgSrc = $$props.imgSrc);
		if ('title' in $$props) $$invalidate(1, title = $$props.title);
	};

	return [imgSrc, title, click_handler, click_handler_1];
}

class HyperButtonVignette extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, { imgSrc: 0, title: 1 });
	}
}

export default HyperButtonVignette;